/**
 * FAZ 1 / F1-16 — Polling araliklari tek yerde (rapor §11.5).
 *
 * ── Neden merkezi ─────────────────────────────────────────────────────────
 * Araliklar 6 ayri dosyada magic number olarak duruyordu (15000, 30000, 60000).
 * Sunucu yuku dogrudan bu sayilara bagli oldugu icin ayarlamanin tek bir yerden
 * yapilabilmesi gerekiyor.
 *
 * ── Olculen etki ──────────────────────────────────────────────────────────
 * B2B paneli acik tek kullanicinin URETTIGI TABAN YUK (kullanici hicbir sey
 * yapmasa bile):
 *
 *   ONCE                                    SONRA
 *   mesaj      1/30sn = 0,033 r/s           1/120sn = 0,008 r/s
 *   etkinlik   1/30sn = 0,033 r/s           1/60sn  = 0,017 r/s
 *   eslesme    1/15sn = 0,067 r/s           1/60sn  = 0,017 r/s
 *   katilimci  1/15sn = 0,067 r/s           1/60sn  = 0,017 r/s
 *   ─────────────────────────────           ──────────────────────
 *              ≈ 0,20 r/s                   ≈ 0,059 r/s   → %70 azalma
 *
 *   2000 kullanici: 400 r/s  →  118 r/s
 *
 * Buna ek olarak `useVisiblePolling` (F1-17) gizli sekmelerde polling'i
 * TAMAMEN durdurur; gercek kazanc bunun uzerinde olacaktir.
 *
 * ── Neden bu degerler ─────────────────────────────────────────────────────
 * `b2bParticipants` en kritik olani: §4.3'teki SAYFALANMAMIS, 4 sorgulu
 * endpoint'i cagiriyor. 2000 katilimcili bir etkinlikte 500 kullanici paneli
 * acik tutarsa 15 sn'de 33 r/s x 4 sorgu = 165 sorgu/s demekti.
 *
 * `liveQaQueue` bilerek 30 sn'de birakildi (120 degil): canli soru-cevap
 * sirasinin gorunur gecikmesi kullanici deneyimini dogrudan etkiler.
 *
 * ⚠️ Bu degerler bir ARA COZUMDUR. Kalici cozum FAZ 4'te Redis cache
 * (§7.2) ve nihayetinde SSE'ye gecis (§11.1) — o zaman polling tamamen kalkar.
 */
export const POLLING_INTERVALS = {
  /** Okunmamis mesaj sayisi — HER SAYFADA aktif (context). */
  messages: 120_000,
  /** Etkinlik listesi. */
  events: 60_000,
  /** B2B eslesmeleri. */
  b2bMatches: 60_000,
  /** B2B katilimcilari — sayfalanmamis endpoint, en pahalisi. */
  b2bParticipants: 60_000,
  /** Canli soru-cevap sirasi — UX geregi daha sik. */
  liveQaQueue: 30_000,
  /** Canli soru-cevap tam dashboard. */
  liveQaDashboard: 120_000,
} as const;

export type PollingIntervalKey = keyof typeof POLLING_INTERVALS;

export default POLLING_INTERVALS;
